import React, { useCallback, useEffect, useState } from "react";
import SideBar from "../../../components/sidebar";
import { IoCloseOutline } from "react-icons/io5";
import { IoIosCloseCircle } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import { FaPaintBrush } from "react-icons/fa";
import { ChromePicker } from "react-color";
import { useDispatch } from "react-redux";
import * as action from "../../../redux/desingReducer";
import { useSelector } from "react-redux";
import Header from "../../../components/layout/Header";
import useWindowSize from "../../../hooks/useWindowSize";
import Navbar from "../components/navbar-for-small-screen/CpanelNavbarForSmallScreen";
import { get, post } from "../../../services/apiService"; // Removed unused 'patch' import
import BackdropLoader from "../../../components/common/BackdropLoader";


const Template = ({ children, navLinks }) => {
  const primaryColor = useSelector((state) => state.primaryColor);
  const previewMode = useSelector((state) => state.previewMode);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true); //for sidebar
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isOpenThemePlate, setThemePlate] = useState(false); //for theme color
  const [isLoading, setIsLoading] = useState(false);
  const [theme, setTheme] = useState({});
  const [themeColor, setThemeColor] = useState(primaryColor);
  const { width: screenWidth } = useWindowSize();

  const handleColorChange = (color) => {
    setThemeColor(color.hex); // Update the theme color
    dispatch(action.SetNewColor({ newColor: color.hex }));
  };
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  function SetMode(mode) {
    dispatch(action.SetPreviewMode({ data: mode }));
  }

  useEffect(() => {
    screenWidth > 900 ? setIsOpen(true) : setIsOpen(false);
  }, [screenWidth]);

  const userId = sessionStorage.getItem("userId");
  const onLoading = () => {};

  const onBackdropLoader = (isLoading) => {
    setIsLoading(isLoading);
  };

  const fetchUserTheme = useCallback(async () => {
    const response = await get(`users/${userId}/theme`, {}, onLoading);
    if (response?.status === 200) {
      const theme = response.data || "#E3E3E3";
      if(theme.tenantId) {
        sessionStorage.setItem("tenantId", theme.tenantId);
      }
      
      setTheme(theme);
      setThemeColor(theme.primaryColor);
      dispatch(action.SetNewColor({ newColor: theme.primaryColor }));
      // Removed setThemeId line since we're not using themeId
    }
  }, [userId, dispatch]); // Added dispatch to dependency array

  useEffect(() => {
    fetchUserTheme();
  }, [fetchUserTheme]);

  const handleSaveTheme = async (theme) => {

    const themeObject = {
      themeId: Number(theme.id),
      primaryColor: themeColor,
    };
    const response = await post(
     `users/${userId}/theme`,
      themeObject,
      {},
      onBackdropLoader
    );
    console.log('theme response', response);
    if (response?.status === 200 ||  response.status === 201) {
      sessionStorage.setItem("themeId", response.data.id);
      // setThemePlate(false);
      window.location.reload();
    }
  };


  return (
    <div>
      <div className={`  flex flex-flex  w-full `}>
        {previewMode ? (
          ""
        ) : (
          <SideBar
            isOpen={isOpen}
            toggleSidebar={() => toggleSidebar()}
            setThemePlate={() => setThemePlate(true)}
            setPreviewMode={() => SetMode(true)}
            sidebarItems={navLinks}
          />
        )}

        {/* Header Code Starts here */}
        <div className={`w-full  h-screen  relative overflow-scroll `}>
          {/* {previewMode ? (
            ""
          ) : ( */}

          {/* <div
              className="py-5  bg-white px-7 flex flex-row justify-between items-center shadow-md fixed z-50 "
              style={{ width: isOpen ? `calc(100% - 18rem)` : "100%" }} // 18rem corresponds to w-72 in Tailwind
            >
              <div className="flex flex-row items-center space-x-4">
                <div className="border border-[#9B59B6] hover:bg-[#9B59B6] text-[#9B59B6] cursor-pointer duration-300  px-3 pt-1.5 rounded-md hover:text-white text-base">
                  Publish Website
                </div>
                <div
                  onClick={() => SetMode(true)}
                  className="border border-[#9B59B6] hover:bg-[#9B59B6] text-[#9B59B6] cursor-pointer duration-300  px-3 pt-1.5 rounded-md hover:text-white text-base"
                >
                  Preview
                </div>
              </div>
              <div className="text-[#9B59B6] flex flex-row items-center space-x-5">
                <a className="text-base  mt-1.5 font-semibold">Welcome</a>
                <div className="flex flex-row space-x-3 text-2xl ">
                  <FaRegCircleUser />
                  <TfiWorld />
                </div>
              </div>
            </div> */}
          
          {!previewMode && (
            <Header isDashboard={true} onSetMode={() => SetMode(true)} onSetDrawerOpen={(value)=>setIsDrawerOpen(value)} isDrawerOpen={isDrawerOpen} />
          )}
 
          {screenWidth < 900 && (
            <Navbar
              navigationItems={navLinks}
              isDrawerOpen={isDrawerOpen}
              onSetDrawerOpen={(value) => setIsDrawerOpen(value)}
            />
          )}
          {/* )}  */}
          {/* Header Code Ends Here */}

          <div className={` ${previewMode ? "" : `mt-20 px-6 pt-4`}`}>
            {children}
            {previewMode && (
              <div className="flex flex-row justify-between absolute bottom-10 right-0">
                <div
                  className="fixed h-14 w-14 bottom-10 right-10 hover:bg-gray-500 rounded-full cursor-pointer bg-gray-400 drop-shadow-xl duration-300 flex items-center justify-center text-2xl text-white"
                  onClick={() => SetMode(false)}
                >
                  <IoCloseOutline className="text-white" />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Theme pallete code starts here */}
        {isLoading && <BackdropLoader />}
        <div className="absolute right-0 top-1/2 transform -translate-y-1/2 flex justify-center items-center">
          {!isOpenThemePlate && (
            <motion.div
              className="h-14 w-14 m-4 bg-opacity-50 rounded-full cursor-pointer bg-gray-400 drop-shadow-xl duration-300 flex items-center justify-center text-2xl text-white"
              onClick={() => setThemePlate(true)}
              initial={{ rotate: 0 }}
              animate={{ rotate: 360 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              <FaPaintBrush className="text-white" />
            </motion.div>
          )}
          {isOpenThemePlate && (
            <AnimatePresence>
              <motion.div
                initial={{ x: "100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "100%", opacity: 0 }}
                transition={{ duration: 0.8, ease: [0.6, -0.05, 0.01, 0.99] }}
                className="relative flex items-center"
              >
                {/* Close Button */}
                <motion.div
                  className="w-min hover:bg-gray-500 m-3 rounded-full cursor-pointer bg-gray-400 duration-300 flex items-center justify-center text-2xl text-white"
                  onClick={() => setThemePlate(false)}
                  initial={{ rotate: 0 }}
                  animate={{ rotate: 360 }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                >
                  <IoIosCloseCircle className="text-white font-bold text-4xl" />
                </motion.div>

                {/* Theme Palette */}
                {theme && (
                  <div className="h-96 w-62 px-7 py-1 bg-white rounded-l-xl overflow-hidden shadow-lg flex flex-col justify-between">
                    <div className="p-4 text-gray-700">
                      <p className="mb-1 font-semibold">
                        Pick Your Theme Color:
                      </p>
                      <ChromePicker
                        color={themeColor}
                        onChange={handleColorChange}
                        disableAlpha={true}
                      />
                      <div
                        className="mt-1 h-10 w-full rounded-lg"
                        style={{ backgroundColor: themeColor }}
                      ></div>
                    </div>

                    {/* Save Button */}
                    <div className="h-36 flex justify-center items-center">
                      <button
                        onClick={() => theme?.id && handleSaveTheme(theme)}
                        className="w-36 text-center bg-blue-500 text-white font-semibold py-4 rounded-lg hover:bg-blue-600 transition"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      </div>
    </div>
  );
};
export default Template;